/**
 * Permissions section of the role create/edit form.
 */
import { Lock } from 'lucide-react';
import { RolePermissionsBuilder } from './RolePermissionsBuilder';
import { parseHierarchyLevel } from '@/components/roles/role-form-utils';
import type { RoleBindingRules, RoleFormState } from '@/types/role.types';
import type { InterfaceElement } from '@/types/interface-elements.types';

/** Props for {@link PostItsAccess}. */
interface PostItsAccessProps {
  fallbackRoleGroup?: string;
  fallbackHierarchyLevel?: number | null;
  visible: boolean;
  onVisibleChange: (visible: boolean) => void;
}

/** Props for {@link RolePermissionsSection}. */
interface RolePermissionsSectionProps {
  form: RoleFormState;
  onBindingsChange: (bindings: Record<string, RoleBindingRules>) => void;
  onElementsLoaded: (elements: Record<string, InterfaceElement[]>) => void;
  disabled?: boolean;
  postItsAccess?: PostItsAccessProps;
}

/** Permissions section of the role create/edit form. */
export function RolePermissionsSection({
  form,
  onBindingsChange,
  onElementsLoaded,
  disabled,
  postItsAccess,
}: Readonly<RolePermissionsSectionProps>) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Lock className="w-4 h-4" />
        Accès et permissions
      </h4>
      <RolePermissionsBuilder
        value={form.bindings}
        onChange={onBindingsChange}
        onElementsLoaded={onElementsLoaded}
        mode={form.mode || undefined}
        hierarchyLevel={
          parseHierarchyLevel(form.hierarchyLevel) ??
          postItsAccess?.fallbackHierarchyLevel ??
          undefined
        }
        roleGroup={form.roleGroup || postItsAccess?.fallbackRoleGroup}
        disabled={disabled}
        postItsAccess={
          postItsAccess
            ? { visible: postItsAccess.visible, onVisibleChange: postItsAccess.onVisibleChange }
            : undefined
        }
      />
    </div>
  );
}
